let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hjKsx")).then(() => parcelRequire('3eDg3'));